import type { Database } from "@/integrations/supabase/types";

type AppRole = Database["public"]["Enums"]["app_role"];

const ROLE_PRIORITY: AppRole[] = ["admin", "landlord", "adjuster", "client", "user"];

const ROLE_DASHBOARDS: Record<AppRole, string> = {
  admin: "/admin",
  landlord: "/landlord-dashboard",
  adjuster: "/adjuster-dashboard",
  client: "/client-dashboard",
  user: "/dashboard",
};

export function getDashboardForRoles(roles: AppRole[]): string {
  for (const role of ROLE_PRIORITY) {
    if (roles.includes(role)) {
      return ROLE_DASHBOARDS[role];
    }
  }
  return "/dashboard";
}

export function getDashboardForRole(role: AppRole): string {
  return ROLE_DASHBOARDS[role] ?? "/dashboard";
}
